<template>
    <div class="flex flex-col gap-4"
        :class="{
            'border border-red-error px-[16px] -mx-[16px] py-[13px]': hasErrorState,
        }"
    >
        <div
            v-for="subOption in stampsOptions"
            :key="subOption.name"
        >
            <div
                class="mb-[16px] font-semibold text-[16px] font-oceanside"
                :class="{
                    'text-red-error': hasErrorState,
                }"
            >
                {{ $t('SELECT_STAMP_COLOR') }}
            </div>
            <step-options-my-palette
                v-if="isAnyPaintfillSelected"
                class="mb-[24px] overflow-hidden"
                :class="hasErrorState ? 'px-[20px]' : '-mx-[40px] px-[40px]'"
                :selected-color="subOption.selectedColor"
                @updateColorIsSelected="handleUpdateSelectedColor(subOption.name, $event)"
            />
            <master-palette
                @updateColorIsSelected="handleUpdateSelectedColor(subOption.name, $event)"
                select-mode="checkmark"
                :selected-color="subOption.selectedColor"
                :has-error-state="hasErrorState"
                :limit-by="subOption.name"
            />
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import MasterPalette from './MasterPalette.vue';
    import StepOptionsMyPalette from './StepOptionsMyPalette.vue';

    export default {
        mixins: [allStores],

        components: {
            MasterPalette,
            StepOptionsMyPalette,
        },

        emits: ['color-selected'],

        data() {
            return {
                activeSubOptionName: null,
            };
        },

        props: {
            hasErrorState: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            stampsOptions() {
                return this.customizerStore?.uiStepSubOptions?.frontStamps || [];
            },

            isAnyPaintfillSelected() {
                return this.customizerStore.isAnyPaintfillSelected();
            },
        },

        methods: {
            handleUpdateSelectedColor(name, paletteValue) {
                const result = this.customizerStore?.requestStepSubOptionColorChange(name, paletteValue);

                if (result) {
                    this.$emit('color-selected', name);
                }

                this.customizerStore.setActiveView('Face');
            },
        },
    };
</script>
